import {createSelector} from "reselect";

export const hasCheckedServices = (state) => {

    const services = state.object?.services;
    let result = false;

    if (services)
    {
        for (let key in services)
        {
            if (services[key]?.values)
            {
                services[key].values.forEach(val => {
                    if (result) return;
                    if (val.selected)
                    {
                        result = true;
                    }
                });
            }
        }
    }

    return result;
}

export const hasCheckedRules = (state) => {
    const rules = state.object?.rules;
    let result = false;

    if (rules)
    {
        for (let key in rules)
        {
            if (rules[key]?.values)
            {
                rules[key].values.forEach(val => {
                    if (result) return;
                    if (val.selected)
                    {
                        result = true;
                    }
                });
            }
        }
    }

    return result;
}

export const getOwnerSelectors = (state) => {

    let mails = state.object?.contact?.mails
    let phones = state.object?.contact?.phones

    if (mails && phones) {
        return  {phones, mails}
    }
}


export const getAccountantSelector = createSelector(getOwnerSelectors, (contacts) => {
    if(contacts) {
        let phones = contacts?.phones?.filter(item => item.accountant === "Y")
        let mails = contacts?.mails?.filter(item => item.accountant === "Y")

        return {phones, mails}
    }
})


export const getNotificationsSelector = createSelector(getOwnerSelectors, (contacts) => {
    if(contacts) {
        let phones = contacts?.phones?.filter(item => item.notification === "Y")
        let mails = contacts?.mails?.filter(item => item.notification === "Y")

        return {phones, mails}
    }
})

